/**
 * orders.api — the signed-in student's checkout and order history.
 *
 * Every call here needs a session token; apiClient attaches it automatically.
 */

import { apiClient } from '@/lib/apiClient';

/**
 * `orderNumber` is a 40-character `rkt_<uuid>` because it doubles as Razorpay's
 * receipt, which must be unique and length-capped. That is unreadable on a
 * receipt screen, so the UI shows its last block — short enough to read aloud
 * to support, and still unique in practice.
 */
export function normalizeOrder(order) {
  if (!order) return order;
  return { ...order, reference: order.orderNumber?.split('-').at(-1)?.toUpperCase() ?? '' };
}

export const ordersApi = {
  create: async (payload) => {
    const envelope = await apiClient.post('/orders', payload);
    return { ...envelope.data, order: normalizeOrder(envelope.data.order) };
  },
  verify: async (payload) => {
    const envelope = await apiClient.post('/orders/verify', payload);
    return normalizeOrder(envelope.data.order);
  },
  listMine: async () => {
    const envelope = await apiClient.get('/orders');
    return envelope.data.orders.map(normalizeOrder);
  },
};

export default ordersApi;
